import CompanyModel, {
  EmployeeCount,
  AdsSpend,
  ClientsCharge,
  Industry,
  JobRole,
  LeadsList,
  OnboardingGoal,
  WebsiteTraffic,
} from '@mm/state/model/CompanyModel';

export const enum SignUpFlowEventsTypes {
  SET_COMPANY = 'SET_COMPANY',
  START = 'START',
  GO_BACK = 'GO_BACK',
  SELECT_JOB_ROLE = 'SELECT_JOB_ROLE',
  SELECT_CLIENTS_CHARGE = 'SELECT_CLIENTS_CHARGE',
  SELECT_TEAM_SIZE = 'SELECT_TEAM_SIZE',
  SELECT_INDUSTRY = 'SELECT_INDUSTRY',
  SET_OTHER_INDUSTRY = 'SET_OTHER_INDUSTRY',
  SELECT_GOAL = 'SELECT_GOAL',
  SELECT_MONTHLY_AD_BUDGET = 'SELECT_MONTHLY_AD_BUDGET',
  SELECT_MONTHLY_WEBSITE_TRAFFIC = 'SELECT_MONTHLY_WEBSITE_TRAFFIC',
  SELECT_LEAD_LIST_SIZE = 'SELECT_LEAD_LIST_SIZE',
  WATCH_VIDEO = 'WATCH_VIDEO',
  CONNECT_CHANNELS = 'CONNECT_CHANNELS',
  SET_NEXT_STEP = 'SET_NEXT_STEP',
}

export type SetCompany = {
  type: SignUpFlowEventsTypes.SET_COMPANY;
  data: {
    company?: CompanyModel;
  };
};

export type StartEvent = {
  type: SignUpFlowEventsTypes.START;
  data: {
    name: string;
    businessEmail: string;
    website: string;
    phoneNumber: string;
  };
};

export type GoBackEvent = {
  type: SignUpFlowEventsTypes.GO_BACK;
};
export type SelectJobRoleEvent = {
  type: SignUpFlowEventsTypes.SELECT_JOB_ROLE;
  data: {
    jobRole: JobRole;
  };
};

export type SelectTeamSizeEvent = {
  type: SignUpFlowEventsTypes.SELECT_TEAM_SIZE;
  data: {
    employeeCount: EmployeeCount;
  };
};

export type SelectClientsChargeEvent = {
  type: SignUpFlowEventsTypes.SELECT_CLIENTS_CHARGE;
  data: {
    clientsCharge: ClientsCharge;
  };
};

export type SelectMonthlyAdBudgetEvent = {
  type: SignUpFlowEventsTypes.SELECT_MONTHLY_AD_BUDGET;
  data: {
    monthlyAdBudget: AdsSpend;
  };
};

export type SelectGoalEvent = {
  type: SignUpFlowEventsTypes.SELECT_GOAL;
  data: {
    goal: OnboardingGoal | string;
  };
};

export type SelectIndustryEvent = {
  type: SignUpFlowEventsTypes.SELECT_INDUSTRY;
  data: {
    industry: Industry | string;
  };
  isOtherIndustrySelected: boolean;
};
export type SetOtherIndustryEvent = {
  type: SignUpFlowEventsTypes.SET_OTHER_INDUSTRY;
};

export type SelectMonthlyWebsiteTrafficEvent = {
  type: SignUpFlowEventsTypes.SELECT_MONTHLY_WEBSITE_TRAFFIC;
  data: {
    websiteVisitors: WebsiteTraffic;
  };
};

export type SelectLeadListEvent = {
  type: SignUpFlowEventsTypes.SELECT_LEAD_LIST_SIZE;
  data: {
    leadsList: LeadsList;
  };
};

export type WatchVideo = {
  type: SignUpFlowEventsTypes.WATCH_VIDEO;
};

export type ConnectChannels = {
  type: SignUpFlowEventsTypes.CONNECT_CHANNELS;
};

export type SetNextStepEvent = {
  type: SignUpFlowEventsTypes.SET_NEXT_STEP;
};

export type SignUpFlowDataEvents =
  | SetCompany
  | StartEvent
  | SelectJobRoleEvent
  | SelectTeamSizeEvent
  | SelectClientsChargeEvent
  | SelectMonthlyAdBudgetEvent
  | SelectIndustryEvent
  | SelectGoalEvent
  | SelectMonthlyWebsiteTrafficEvent
  | SelectLeadListEvent;

export type SignUpFlowEvents =
  | SignUpFlowDataEvents
  | GoBackEvent
  | SetOtherIndustryEvent
  | SetNextStepEvent
  | WatchVideo
  | ConnectChannels;
